import React from "react";
import BaseDetails, { DetailRow, TypeBadge } from "./baseDetails";
import snakeToPascal from "../../tools";

export default function applyPresetDetails({ row }) {
    return (
        <BaseDetails row={row}>
            <DetailRow label="Preset">
                <TypeBadge variant="primary">{snakeToPascal(row.preset_name)}</TypeBadge>
            </DetailRow>
        </BaseDetails>
    );
}
